/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationBaseForGcpSaas extends models.StorageConfigurationForSaasUserManaged {
    getFixupPrototypeFunction() { return StorageConfigurationBaseForGcpSaas.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationBaseForGcpSaas>): StorageConfigurationBaseForGcpSaas {
        let obj = Object.assign(new StorageConfigurationBaseForGcpSaas(), model);
        StorageConfigurationBaseForGcpSaas.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationBaseForGcpSaas>): StorageConfigurationBaseForGcpSaas {
        if (!model) return null;
        return StorageConfigurationBaseForGcpSaas.newInstance(<StorageConfigurationBaseForGcpSaas> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationBaseForGcpSaas) {
        if (!obj) return;

        models.StorageConfigurationBaseForGcpSaas.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationBaseForGcpSaas): boolean {
        if (models.StorageConfigurationForSaasUserManaged.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationBaseForGcpSaas.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * GCP Bucket Name
     */
    bucket_name: string;

    /**
     * File path prefix in the bucket
     */
    file_path: string;

}
